import type { Watch } from '@/lib/myWatches/types';
import type {
  RepairDetails,
  RepairReasonResponse,
  WatchProductSummary,
} from '@/lib/service/ecs/contracts';
import type { WarrantyExtensionOffer } from '@/lib/service/repairDetailsSidebarEligibility';

export interface RepairDetailsWatchSidebarState {
  productSummary: WatchProductSummary | null;
  watchWarranty: Watch | null;
  warrantyCode: number | null;
  warrantyExtensionOffer: WarrantyExtensionOffer | null;
}

export interface RepairDetailsInitialData {
  repairs: RepairDetails[];
  reasonCatalogue?: RepairReasonResponse['items'];
  isLastPage: boolean;
  watchSidebar: RepairDetailsWatchSidebarState | null;
}

export function readPrimaryRepairItem(repair: RepairDetails | undefined) {
  return repair?.repairItems[0];
}

/** Authenticated account links may name one repair; guest `code` is only an access credential. */
export function repairNumberForAccountLink(
  loginRequired: boolean,
  accessCode?: string
): string | undefined {
  return loginRequired ? accessCode?.trim() : undefined;
}

/** Keep the repair named by an account link when ECS returns a wider list. */
export function selectRequestedRepairs(
  items: readonly RepairDetails[] | undefined,
  repairNumber?: string
): RepairDetails[] {
  const repairs = [...(items ?? [])];
  const requested = repairNumber?.trim();
  if (!requested) return repairs;
  return repairs.filter((item) => item.repairNumber === requested);
}
